module.exports = __webpack_public_path__ + "annualreview2017/static/img/utility-scale-storage@0,5x.0a24563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landscape/utility-scale-storage@0,5x.png
// module id = 760
// module chunks = 0